if (!customElements.get('product-card')) {
  customElements.define(
    'product-card',

    /**
     * Custom element for handling product card functionality
     * @class ProductCard
     * @extends HTMLElement
     */
    class ProductCard extends HTMLElement {
      /**
       * Creates an instance of ProductCard
       * @constructor
       */
      constructor() {
        super();
        this.id = this.querySelector('[name=id]')
          ? this.querySelector('[name=id]').value
          : null;
        this.variantId = this.getAttribute('data-variant-id');
        this.submitButton = this.querySelector('.buy-button');
        this.cart =
          document.querySelector('cart-notification') ||
          document.querySelector('cart-drawer');
        this.openCartOnAdd = this.getAttribute('data-open-cart-on-add') === 'true';
        this.disableQuantityControls = this.getAttribute('data-disable-quantity-controls') === 'true';

        if (this.submitButton != null) {
          this.submitButton.addEventListener(
            'click',
            this.productSubmit.bind(this)
          );
        }
        this.lastAmount = 0;
        this.buyButton = this.querySelector('.buy-button');
        this.ChangeButton = this.querySelector('.change-button');
        this.quantity_input = this.querySelector('.quantity_input');
        this.quantity_button_minus = this.querySelector(
          '.quantity_button.minus'
        );
        this.quantity_button_plus = this.querySelector('.quantity_button.plus');
        if (this.quantity_button_minus != null)
          this.quantity_button_minus.addEventListener(
            'click',
            this.quantityMinus.bind(this)
          );
        if (this.quantity_button_plus != null)
          this.quantity_button_plus.addEventListener(
            'click',
            this.quantityPlus.bind(this)
          );
        if (this.quantity_input != null) {
          this.quantity_input.addEventListener(
            'change',
            this.quantityInput.bind(this)
          );
        }
        this.cartUpdateUnsubscriber = undefined;
      }

      /**
       * Called when the element is connected to the DOM
       */
      connectedCallback() {
        this.cartUpdateUnsubscriber = subscribe(
          PUB_SUB_EVENTS.cartUpdate,
          (event) => {
            let itemsToBeRemoved = [];

            if (event.source === 'product-card' && event.variantId == this.variantId) {
              

              if (event.updateType === 'add') {
                this.syncFromAddToCart();
              } else {
                this.syncFromCartState(event.cartState);
              }
            }
            
            // Handle items removed from cart (similar to cre-cart.js logic)
            if (event.cartState && event.cartState.items_removed) {
              const variantIdsInCart = event.cartState.items ? event.cartState.items.map(item => item.variant_id) : [];
              itemsToBeRemoved = event.cartState.items_removed.filter(removedItem => {
                return !variantIdsInCart.includes(removedItem.variant_id);
              });

              itemsToBeRemoved.forEach((item) => {
                console.log('cdebug product-card items_removed', item);
                const productCards = document.querySelectorAll(
                  "[data-variant-id='" + item.variant_id + "']"
                );
                productCards.forEach((productCard) => {
                  if (productCard == null || productCard == undefined) return;
                  const buyButton = productCard.querySelector('.buy-button');
                  const changeButton = productCard.querySelector('.change-button');
                  const quantityInput = productCard.querySelector('.quantity_input');
                  
                  if (buyButton) buyButton.classList.add('active');
                  if (changeButton) changeButton.classList.remove('active');
                  if (quantityInput) quantityInput.value = 0;
                });

              });
            }
          }
        );
      }

      /**
       * Called when the element is disconnected from the DOM
       */
      disconnectedCallback() {
        if (this.cartUpdateUnsubscriber) {
          this.cartUpdateUnsubscriber();
        }
      }

      /**
       * Syncs the product card UI based on cart state
       * @param {Object} cartState - The cart state from the API response
       */
      syncFromCartState(cartState) {
        if (!cartState || !cartState.items) return;
        
        const cartItem = cartState.items.find(item => item.variant_id == this.variantId);
        
        if (cartItem && cartItem.quantity > 0 && !this.disableQuantityControls) {
          // Item is in cart and quantity controls are enabled - show quantity controls
          this.buyButton.classList.remove('active');
          this.ChangeButton.classList.add('active');
          this.quantity_input.value = cartItem.quantity;
        } else {

          console.log('cdebug product-card', this.variantId, cartItem, this.disableQuantityControls, this.buyButton, this.ChangeButton);
          // Item not in cart OR quantity controls are disabled - show add to cart button
          this.buyButton.classList.add('active');
          this.ChangeButton.classList.remove('active');
          this.quantity_input.value = cartItem.quantity;
        }
      }

      /**
       * Syncs the product card UI when an item is added to cart
       * This handles the case where cartState structure is different for add operations
       */
      syncFromAddToCart() {
        console.log('cdebug syncFromAddToCart', this.variantId, this.disableQuantityControls);
        
        if (!this.disableQuantityControls) {
          // Item was just added to cart and quantity controls are enabled - show quantity controls
          this.buyButton.classList.remove('active');
          this.ChangeButton.classList.add('active');
          this.quantity_input.value = 1;
        } else {
          // Quantity controls are disabled - keep showing add to cart button
          this.buyButton.classList.add('active');
          this.ChangeButton.classList.remove('active');
          this.quantity_input.value = 1;
        }
      }

      /**
       * Updates the quantity of a product in the cart
       * @param {number} num - The amount to change the quantity by
       */
      updateQuantity(num) {
        this.lastAmount = this.quantity_input.value;
        this.quantity_input.value = parseInt(this.quantity_input.value) + num;

        let amount = parseInt(this.quantity_input.value);

        this.ChangeButton.classList.add('loading');

        this.quantity_button_plus.setAttribute('disabled', '');
        this.quantity_button_minus.setAttribute('disabled', '');
        this.quantity_input.setAttribute('disabled', '');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
        const formData = new FormData();
        formData.append('id', this.id);
        formData.append('quantity', amount);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch('/cart/change.js', config)
          .then((response) => {
            if (!response.ok) {
              throw new Error('Failed to update cart.');
            }
            return response.json();
          })
          .then((response) => {
            if (amount <= 0) {
              this.buyButton.classList.add('active');
              this.ChangeButton.classList.remove('active');
              this.quantity_input.value = 0;
            }
            this.cart.renderContents1(response);
            this.lastAmount = amount;
            
            // Publish event for other product cards
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'product-card',
              variantId: this.variantId,
              cartState: response
            });
          })
          .catch((err) => {
            if (this.lastAmount > 0) {
              this.quantity_input.value = this.lastAmount;
              this.lastAmount = this.quantity_input.value;
            } else {
              this.buyButton.classList.add('active');
              this.ChangeButton.classList.remove('active');
              this.quantity_input.value = 0;
              this.lastAmount = 0;
            }
          })
          .finally(() => {
            this.ChangeButton.classList.remove('loading');
            this.quantity_button_minus.removeAttribute('disabled');
            this.quantity_button_plus.removeAttribute('disabled');
            this.quantity_input.removeAttribute('disabled');
          });
      }

      /**
       * Decreases the product quantity by 1
       * @param {Event} e - The click event
       */
      quantityMinus(e) {
        this.updateQuantity(-1);
      }

      /**
       * Handles direct quantity input changes
       * @param {Event} e - The change event
       */
      quantityInput(e) {
        this.updateQuantity();
      }

      /**
       * Increases the product quantity by 1
       * @param {Event} e - The click event
       */
      quantityPlus(e) {
        this.updateQuantity(1);
      }

      /**
       * Handles adding a product to cart
       * @param {Event} e - The click event
       */
      productSubmit(e) {
        e.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
        const formData = new FormData();
        formData.append('id', this.id);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => {
            if (!response.ok) {
              throw new Error('Failed to add to cart.');
            }
            return response.json();
          })
          .then((response) => {
            if (!this.disableQuantityControls) {
              this.buyButton.classList.remove('active');
              this.ChangeButton.classList.add('active');
              this.quantity_input.value = 1;
            } else {
              // Keep showing add to cart button when quantity controls are disabled
              this.buyButton.classList.add('active');
              this.ChangeButton.classList.remove('active');
              this.quantity_input.value = 1;
            }
            this.cart.renderContents1(response);
            
            // Publish event for other product cards
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'product-card',
              updateType: 'add',
              variantId: this.variantId,
              cartState: response
            });
          })
          .finally(() => {
            this.submitButton.setAttribute('aria-disabled', false);
            this.submitButton.classList.remove('loading');
            if (this.openCartOnAdd && this.cart) {
              this.cart.open();
            }
          });
      }
    }
  );
}

/**
 * Refreshes the cart drawer contents
 * @function cartRefresh
 */
function cartRefresh() {
  fetch('/cart?section_id=cart-drawer', {
    method: 'get',
  })
    .then((res) => {
      return res.text();
    })
    .then((res) => {
      const html = new DOMParser().parseFromString(res, 'text/html');
      document.querySelector('#CartDrawer').innerHTML =
        html.querySelector('#CartDrawer').innerHTML;
    });
}
